import { ScaffoldPage } from '@/components/layout/ScaffoldPage'
import { buildBreadcrumbs } from '@/config/routes'

export default function Deletion() {
  return (
    <ScaffoldPage
      title="Data Deletion"
      description="Process GDPR/CCPA deletion requests and manage manual data removal."
      breadcrumbs={buildBreadcrumbs('/settings/governance/deletion')}
      plannedFeatures={[
        'GDPR right-to-erasure request processing',
        'CCPA deletion request handling',
        'Bulk data deletion for decommissioned profiles',
        'Deletion verification and audit trail',
      ]}
      relatedPages={[
        { label: 'Retention Policies', href: '/settings/governance/retention' },
        { label: 'Compliance Status', href: '/settings/compliance/status' },
      ]}
    />
  )
}
